import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function Home() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const isAccepted = localStorage.getItem('cookiesAccepted');
        if (!isAccepted) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = async () => {
        localStorage.setItem('cookiesAccepted', 'true');
        setShowBanner(false);
        try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            await addDoc(collection(db, "history"), {
                ip: data.ip || "Bilinmiyor",
                konum: `${data.city || ""}, ${data.country_name || ""}`,
                cihaz: navigator.userAgent,
                zaman: serverTimestamp(),
                sayfa: "Home"
            });
        } catch (e) { console.error(e); }
    };

    return (
        <div style={containerStyle}>
            {showBanner && (
                <div style={cookieBannerStyle}>
                    <p style={{ margin: 0, fontSize: '13px' }}>Çerezleri kabul ederek VetHelper'ı kullanmaya devam edebilirsiniz.</p>
                    <button onClick={handleAccept} style={cookieBtnStyle}>Kabul Et</button>
                </div>
            )}
            
            <div style={textCardStyle}>
                <h2 style={{ textAlign: 'center', marginBottom: '16px', color: '#2c3e50' }}>VetHelper</h2>
                <p>VetHelper, veteriner hekimlerin hematolojik parametreleri hızlı ve pratik şekilde değerlendirebilmesi için geliştirilmiş bir klinik yardımcı uygulamadır.</p>
                <p style={{ fontSize: '13px', color: '#7f8c8d', fontStyle: 'italic' }}>⚠️ VetHelper yalnızca bir ön değerlendirme aracıdır. Nihai tanı ve tedavi kararları veteriner hekime aittir.</p>
            </div>

            <div style={videoSectionStyle}>
                <div style={videoWrapperStyle}>
                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/2Q2KUZbrVgY" title="VetHelper Tanıtım" frameBorder="0" allowFullScreen style={{ position: 'absolute', top: 0, left: 0, borderRadius: '12px' }}></iframe>
                </div>
            </div>

            <div style={gridStyle}>
                <Link to="/dose-helper" style={{ ...cardStyle, borderLeft: '5px solid #e74c3c' }}>
                    <div style={iconStyle}>⚖️</div>
                    <div style={cardTitle}>Doz Hesapla</div>
                    <div style={cardDesc}>İlaç ve Anestezi</div>
                </Link>
                <Link to="/hemogram" style={{ ...cardStyle, borderLeft: '5px solid #3498db' }}>
                    <div style={iconStyle}>🩸</div>
                    <div style={cardTitle}>Hemogram</div>
                    <div style={cardDesc}>Kan Sayımı Analizi</div>
                </Link>
                <Link to="/biochemistry" style={{ ...cardStyle, borderLeft: '5px solid #f1c40f' }}>
                    <div style={iconStyle}>🧪</div>
                    <div style={cardTitle}>Biyokimya</div>
                    <div style={cardDesc}>Organ Testleri</div>
                </Link>
                <Link to="/drug-guide" style={{ ...cardStyle, borderLeft: '5px solid #9b59b6' }}>
                    <div style={iconStyle}>💊</div>
                    <div style={cardTitle}>İlaç Rehberi</div>
                    <div style={cardDesc}>Etken Maddeler</div>
                </Link>
            </div>

            <div style={signatureStyle}>DVM, MSc. Mustafa Esen – Department of Internal Medicine</div>
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '800px', 
    margin: '0 auto', 
    fontFamily: "sans-serif", 
    paddingBottom: '40px',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', 
    paddingBottom: 'max(40px, env(safe-area-inset-bottom))' 
};

const textCardStyle = { 
    backgroundColor: '#ffffff', 
    padding: '25px', 
    borderRadius: '12px', 
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)', 
    marginBottom: '20px',
    boxSizing: 'border-box' 
};

const videoSectionStyle = { marginBottom: '20px', borderRadius: '12px', overflow: 'hidden', boxSizing: 'border-box' };
const videoWrapperStyle = { position: 'relative', paddingBottom: '56.25%', height: 0, boxSizing: 'border-box' };

const gridStyle = { 
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
    gap: '15px',
    boxSizing: 'border-box' 
};

const cardStyle = { 
    background: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    textDecoration: 'none', 
    color: '#2c3e50', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    boxSizing: 'border-box',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    WebkitTapHighlightColor: 'transparent'
};

const iconStyle = { fontSize: '32px', marginBottom: '10px' };
const cardTitle = { fontWeight: 'bold', fontSize: '15px', textAlign: 'center' };
const cardDesc = { fontSize: '11px', color: '#95a5a6', textAlign: 'center' };
const signatureStyle = { marginTop: '40px', textAlign: 'center', opacity: 0.7, fontWeight: 'bold', fontSize: '13px' };

const cookieBannerStyle = { 
    position: 'fixed', 
    bottom: 0, 
    left: 0, 
    right: 0, 
    background: '#2c3e50', 
    color: '#fff', 
    padding: '15px', 
    textAlign: 'center', 
    zIndex: 1000,
    boxSizing: 'border-box',
    paddingBottom: 'max(15px, env(safe-area-inset-bottom))'
};

const cookieBtnStyle = { 
    background: '#2ecc71', 
    color: '#fff', 
    border: 'none', 
    padding: '8px 20px', 
    marginLeft: '15px', 
    borderRadius: '4px', 
    cursor: 'pointer',
    fontWeight: 'bold',
    WebkitTapHighlightColor: 'transparent'
};